export default "__VITE_PUBLIC_ASSET__d459d5e9__"